<template>
  <reusable-dialog v-model="isVisibleTimezoneAreaList">
    <div
      v-for="area in formattedTimezoneAreaList"
      :key="area.id"
      :class="$style.area"
    >
      <option-panel :active="area.active" @click="handleSelect(area)">
        <span slot="title">{{ area.code }}</span>
      </option-panel>
    </div>
  </reusable-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

import OptionPanel from 'molecules/panels/OptionPanel';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TimezoneAreaDialog',
  components: {
    OptionPanel,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_TIMEZONE_AREA_LIST', () => {
      this.isVisibleTimezoneAreaList = true;
    });
  },
  data() {
    return {
      isVisibleTimezoneAreaList: false,
    };
  },
  computed: {
    formattedTimezoneAreaList() {
      return this.getTimezoneAreaList.map(area => {
        const isActiveArea = area.id === this.getCurrentTimezoneAreaId;

        return {
          ...area,
          active: isActiveArea,
        };
      });
    },
    ...mapGetters('timezone', [
      'getTimezoneAreaList',
      'getCurrentTimezoneAreaId',
      'getTimezoneListMapByAreaGroup',
    ]),
  },
  methods: {
    handleSelect(area) {
      const timezoneList = this.getTimezoneListMapByAreaGroup[area.code];

      this.$emit('change', timezoneList[0]);
      this.isVisibleTimezoneAreaList = false;
    },
  },
};
</script>

<style lang="sass" module>
  .area
    &:not(:last-child)
      margin-bottom: 10px
</style>
